export const PdfConstants = {

    footerCopyRight: "© Copyright 2020-2026 HP Development Company, LP. The information contained herein is subject to change without notice. The only warranties for HP products and services are set forth in the express warranty statement accompanying such products and services. Nothing herein should be construed as constituting an additional warranty. HP shall not be liable for technical or editorial errors or omissions contained herein.",

}

export const WelcomeText = {
    urls: {
        requestForm: "https://app.smartsheet.com/b/form/9930b3acbbd845d8b93bad4915f43392",
        resellerLocator: "https://locator.hp.com/",
        compatibleDeviceList: "https://developers.hp.com/workpath/compatible-devices",
        aboutWorkpath: "https://h20195.www2.hp.com/v2/GetPDF.aspx/4AA7-3703ENW.pdf",
        aboutPremiumApps: "",
        alternativeDeployment: "https://support.hp.com/sg-en/document/ish_13877154-13872747-16",
        brandedApps: "https://support.hp.com/sg-en/drivers/hp-workpath-apps/24094090",
    },

    referenceLinksHeading: "Reference Documentation",
    referenceLinks: [
        { label: "About HP Workpath", urlKey: "aboutWorkpath" },
        { label: "About HP Workpath Premium Apps", urlKey: "aboutPremiumApps" },
        { label: "FAQ: Alternative Deployment Options", urlKey: "alternativeDeployment" },
        { label: "HP Workpath Compatible Device List", urlKey: "compatibleDeviceList" },
        {
            label: "HP-Branded Apps for Direct Download",
            suffix: "(requires essential or premium license)",
            urlKey: "brandedApps",
        },
    ],

    welcome: "Welcome to the HP Workpath Apps Catalog!",

    introBeforeFootnote: [
        { text: "Unlock a world of possibilities with " },
        { text: "HP and third-party apps", bold: true },
        {
            text: " that are designed to expand and evolve the capabilities of your HP Workpath-enabled printers",
        },
    ],
    introAfterFootnote: [
        { text: ". Check out the entire catalog of apps created to " },
        {
            text: "enhance workflows and streamline your digitization process, while helping secure confidential information",
            bold: true,
        },
        { text: "." },
    ],
    filterHint:
        "Use the Filter tab to search by country of availability, brand, app type, industry, and/or license type.",

    licenseIntro:
        "HP Workpath Apps can be used via HP Cloud connected systems or via feature license local to the device, for ultimate flexibility and connectivity needs.",
    licenseListHeading: "To use HP Workpath apps via feature license:",
    licenseList: [
        "Install HP Workpath Essential apps alongside the HP Workpath Essential license (free, perpetual license).",
        "Install HP Workpath Premium apps alongside the HP Workpath Premium license (year terms available).",
        "To run both Essential and Premium apps, install both HP Workpath Essential License and HP Workpath Premium license on the device.",
    ],

    security:
        "All apps available on the Workpath platform have passed the HP Verification and Validation (V&V) processes to help ensure app security.",

    contact: "Contact your HP representative for information on how to purchase HP Workpath apps.",
    assistanceBeforeForm:
        "For assistance in finding a local HP representative, please complete the",
    requestFormLabel: "HP Request Form",
    assistanceBeforeLocator: "or visit",
    resellerLocatorLabel: "The HP Reseller Locator",
    assistanceAfterLocator: "(select business and filter by specialization/HP Workpath).",

    footnoteBeforeLink: "See the",
    compatibleDeviceListLabel: "Workpath compatible device list",
    footnoteAfterLink:
        "for details on printers that support HP Workpath apps. Not all apps may be available in all locations.",
};

const plainText = (segments) => segments.map((segment) => segment.text).join("");

export const WelcomePdfText = {
    paragraph1: WelcomeText.welcome,
    paragraph2: `${plainText(WelcomeText.introBeforeFootnote)}¹${plainText(WelcomeText.introAfterFootnote)}`,
    filterHint: WelcomeText.filterHint,
    paragraph3: WelcomeText.licenseIntro,
    paragraph4: WelcomeText.licenseListHeading,
    bullets: WelcomeText.licenseList,
    paragraph5: WelcomeText.security,
    paragraph6: `${WelcomeText.contact} ${WelcomeText.assistanceBeforeForm} ${WelcomeText.requestFormLabel} ${WelcomeText.assistanceBeforeLocator} ${WelcomeText.resellerLocatorLabel} ${WelcomeText.assistanceAfterLocator}`,
    paragraph6Links: [
        { label: WelcomeText.requestFormLabel, url: WelcomeText.urls.requestForm },
        { label: WelcomeText.resellerLocatorLabel, url: WelcomeText.urls.resellerLocator },
    ],
    footnote: `¹${WelcomeText.footnoteBeforeLink} ${WelcomeText.compatibleDeviceListLabel} ${WelcomeText.footnoteAfterLink}`,
    footnoteLinks: [
        { label: WelcomeText.compatibleDeviceListLabel, url: WelcomeText.urls.compatibleDeviceList },
    ],
};